// extracted by css-extract-rspack-plugin
var _1 = "IXeNiza5UVoLyXLA";
export { _1 as "inlineIcon" }
// extracted by css-extract-rspack-plugin
var _1 = "IXeNiza5UVoLyXLA";
export { _1 as "inlineIcon" }
